<script setup lang="ts">
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

import { Star } from "lucide-vue-next";

interface ReviewProps {
  image: string;
  name: string;
  userName: string;
  comment: string;
  rating: number;
}

const reviewList: ReviewProps[] = [
  {
    image: "https://github.com/shadcn.png",
    name: "张总",
    userName: "华东制造集团 - 总工程师",
    comment:
      "创诚的物联网+AI解决方案帮助我们实现了生产设备的智能化管理，设备故障率降低了60%，生产效率提升显著。",
    rating: 5.0,
  },
  {
    image: "https://github.com/shadcn.png",
    name: "李经理",
    userName: "绿源环保科技 - 项目经理",
    comment:
      "他们的环境监测系统非常专业，数据准确性高，预警及时，为我们的环保工作提供了强有力的技术支撑。",
    rating: 4.9,
  },
  {
    image: "https://github.com/shadcn.png",
    name: "王主任",
    userName: "智慧园区管理中心 - 技术主任",
    comment:
      "创诚团队的服务态度很棒，从需求分析到系统部署都很专业，7x24小时的运维支持让我们很放心。",
    rating: 5.0,
  },
  {
    image: "https://github.com/shadcn.png",
    name: "陈工",
    userName: "精密仪器制造 - 首席工程师",
    comment:
      "他们的智能仪器仪表精度很高，数据采集稳定可靠，完全满足我们的高精度测量需求。",
    rating: 4.8,
  },
  {
    image: "https://github.com/shadcn.png",
    name: "刘总监",
    userName: "新能源公司 - 技术总监",
    comment:
      "能耗管理系统帮助我们实现了精细化能源管理，每月节约用电成本20%以上，投资回报率很高。",
    rating: 5.0,
  },
  {
    image: "https://github.com/shadcn.png",
    name: "赵部长",
    userName: "工业园区 - 信息化部长",
    comment:
      "整套工业自动化控制系统运行稳定，界面友好，大大提升了我们的生产管理水平和工作效率。",
    rating: 4.9,
  },
];
</script>

<template>
  <section
    id="testimonials"
    class="container py-24 sm:py-32"
  >
    <div class="text-center mb-8">
      <h2 class="text-lg text-primary text-center mb-2 tracking-wider">
        客户评价
      </h2>

      <h2 class="text-3xl md:text-4xl text-center font-bold mb-4">
        听听我们客户的真实反馈
      </h2>
    </div>

    <Carousel
      :opts="{
        align: 'start',
      }"
      class="relative w-[80%] sm:w-[90%] lg:max-w-screen-xl mx-auto"
    >
      <CarouselContent>
        <CarouselItem
          v-for="review in reviewList"
          :key="review.name"
          class="md:basis-1/2 lg:basis-1/3"
        >
          <Card class="bg-muted/50 dark:bg-card">
            <CardContent class="pt-6 pb-0">
              <div class="flex gap-1 pb-6">
                <Star class="size-4 fill-primary text-primary" />
                <Star class="size-4 fill-primary text-primary" />
                <Star class="size-4 fill-primary text-primary" />
                <Star class="size-4 fill-primary text-primary" />
                <Star class="size-4 fill-primary text-primary" />
              </div>

              "{{ review.comment }}"
            </CardContent>

            <CardHeader>
              <div class="flex flex-row items-center gap-4">
                <Avatar>
                  <AvatarImage
                    src="https://www.radix-vue.com/logo.svg"
                    alt="@radix-vue"
                  />
                  <AvatarFallback>SV</AvatarFallback>
                </Avatar>

                <div class="flex flex-col">
                  <CardTitle class="text-lg">{{ review.name }}</CardTitle>
                  <CardDescription>{{ review.userName }}</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>
        </CarouselItem>
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  </section>
</template>
